import {
  getHideFeeTypeByGroupId,
  getSkinData,
  Get_rowcolor,
  Add_rowcolor,
  getBSite
} from '@/api/commonController'
import { getNoticeNotRead } from '@/api/noticeController'
import { getSuperSettingUser } from '@/api/quickFindResultController'
import {
  getArg,
  selectVehicleXinghao,
  GetConsignee
} from '@/api/loadInfoController'
// import {
//   // getPageData
//   // GetFHSITE,陈俊辉
//   // addHXSITE,陈俊辉
//   // delHXSITE,陈俊辉
//   // addPZSITE,陈俊辉
//   // delPZSITE,陈俊辉
//   // addFHSITE,陈俊辉
//   // delFHSITE,陈俊辉
//   // addFEELVSITE,陈俊辉
//   // delFEELVSITE,陈俊辉
//   // addPG,陈俊辉
//   // delPG陈俊辉
// } from '@/api/parmSettingController'
import {
  getMapUrl,
  getVehicleExpires,
  myGPSinfo
} from '@/api/transportResourcesController'
import {
  qsoGetOutDirectMonitor,
  qspGetChaufferMonitor,
  qspGetCountMonitor,
  qspGetOkProcessMonitor,
  qspGetTurnOverMonitor,
  qspGetWeightMonitor
} from '@/api/bichartController'
import { getHomeStatisticsData } from '@/api/homeController'
import {
  // getInterval,
  // getIntervalNoAll,
  publicDataDecryptColumn,
  checkOutexcel,
  downLoadExportExcel2,
  getSite,
  GetSiteRole,
  downLoadExportExcel,
  downLoadExportExcel3,
  GetFeetype,
  PubilcDataDecrypt,
  Getusername
} from '@/api/publicDataController'
import {
  getGridColumns,
  getGridColumnsByGridID,
  getGridUserSettings,
  getExportModelMain,
  GetBackData,
  GetDataDictionary,
  GridManaQuery,
  GetPageGridBond,
  SavePGSData
} from '@/api/sysManaController'
import {
  getImg,
  delpicture,
  uploadImg,
  GetImg,
  GetImgCommon,
  DelpictureByID,
  UploadImgGPYS
} from '@/api/checkImgController'
import { getTydSort, GetShipperAgain } from '@/api/billingController'
import { getChaufferBillno } from '@/api/settlementController'
import {
  getSmsClassData,
  getClassName,
  getSmsModelData,
  saveSmsModel,
  getSmsManDataNew,
  uploadExecl,
  getSMSCost
} from '@/api/smsPlatform'
import { getSiteTree } from '@/api/customerProfilesController'
import {
  ImportCardMaterialMain,
  DeleteIntoCardMaterialExcel,
  InitializationTemplate,
  GetCardMaterialflag,
  ImportCardMaterialData,
  Get_Template_Main,
  GetIntoCardMaterialExcel,
  CardMaterialTemplateDelete,
  oilCardGetPageGridBond,
  oilCardSavePGSData
} from '@/api/vehicleOilCardController'
import {
  IsExistFile,
  CustomerInformationTemplateDelete,
  // templateSavePGSData,
  templateGetPageGridBond
} from '@/api/customerInformationTemplate'
import { getVehicleXinghao } from '@/api/vehicleXinghaoController'
import { DeliveryRecordIndex, DeliveryRecordPushWb, VerifyAccend, CancelVerifyAccend, SaveAdrr } from '@/api/deliveryRecordController'
import {
  Add_sh,
  AddClaimsSettlement,
  CancelClaimsSettlement
} from '@/api/claimsSettlementController'
import {
  Add_REFEREE,
  BILLNO_getunit,
  AddCargodamageInfo,
  GetCargodamageInfo,
  DeleteCargodamage,
  CancelRShipment
} from '@/api/qualityManageController'
import { sectorInformation } from '@/api/personnelAdministration'
import { GET_YGDA_INFO, get_gzori } from '@/api/paymentWelfare'
import {
  warehousingDetails,
  getCourierDetailsData,
  scanCode,
  addBKDorder,
  ordeRenterInfoWid,
  Del_B_KD_ORDER,
  ADD_B_KD_ORDER_detail,
  B_KD_ORDER_detail,
  warehousingManagement
} from '@/api/courierController'
import {
  GetModifyData_ClaimsSettlement,
  GetModifyData_Company,
  GetModifyData_Users,
  GetModifyData_BillingTemplateList,
  GetModifyData_Warehousing_76972
} from '@/api/getModifyDataOneController'
import {
  // SaveLinesOrder,
  B_other_company
  // codeData,
  // LinesData,
  // bsiteData,
  // SaveBatchList
} from '@/api/zzjg'
import {
  // GetSendAreaPrice,
  // GetSendStartPrice,
  AddPriceRange,
  DeletePriceRange,
  UpdateRangeMinValue,
  // DeleteDeliveryCharge,
  // DeleteDeliveryCharge3,
  // DeleteDeliveryCharge78633,
  // DeleteDeliveryCharge86250,
  InitCarriageTemplateData,
  // priceSystemAdd,
  SaveDeliveryData,
  SaveCarriageData,
  SaveCarriageData2,
  SaveDeliveryData86250,
  SaveSafeData,
  SaveSendData,
  SaveJincangData79710,
  SaveCarriageData_76955,
  SaveCarriageData_80799,
  SaveCarriageData_81930,
  SaveCarriageData_96209,
  SaveCarriageData_81003,
  SaveCarriageData_82622,
  SaveCarriageData_79358,
  SaveCarriageData_80028,
  SaveData_GroundLine,
  SaveData_Other,
  SaveDataComm,
  // SaveLinePriceData,
  // SaveItemPriceData,
  SaveFyAddressData
  // SaveEditPrice,
  // SaveEditPrice78633,
  // SaveEditPrice79710,
  // SaveEditPrice80028,
  // SaveEditPrice81003,
  // SaveEditPrice79323,
  // SaveEditPrice82622,
  // SaveEditPrice79358,
  // SaveEditPriceComm,
  // SaveEditPrice86250
} from '@/api/priceSystem'
import {
  // GetRptModel,陈俊辉
  rpttypeQuery,
  rptModelManaDelete,
  rptModelManaSetDefault,
  rptModelManaRemoveDefault,
  getModelByTypeID,
  // GetModelVersion,
  UseModelVersion,
  rptmodelSave,
  CopyModelVersion,
  // rptmodelSaveLog,
  // rptmodelSave_rl_new
} from '@/api/rptmana'
// import { seleteCenterInfo } from '@/api/pinchebao'
// import { NPage_GetPermissList } from '@/api/permissiongroup'陈俊辉
// import {
//   // ModifyUser_post,陈俊辉
//   // GetBSite,
//   // GetDDUser
// } from '@/api/czy'
// import { ChangPassWord_post } from '@/api/toggleSite'陈俊辉
// import { audit, deleteBind } from '@/api/BindingEquipment'
import {
  selectpackpagesbysite,
  selectProductcode,
  addProductcode,
  deleteProductcode,
  selectWeightgesetupbysite,
  selectVolumgesetupbysite
} from '@/api/baseSetting'
import {
  importTemplateIsExistFile,
  importSavePGSData,
  importGetPageGridBond,
  importInitializationTemplate
} from '@/api/ImportTemplate'
import {
  goodsCustomerInformationTemplateDelete,
  goodsCustomerGetPageGridBond,
  goodsCustomerSavePGSData
} from '@/api/goodsTrackingTemplate'
import {
  WarehouseTemplateDelete,
  // WarehouseSavePGSData
} from '@/api/warehouseManagement'
import { warehouseGetPageGridBond } from '@/api/ImportWarehouse'
import { DataDictionaryMapping } from '@/api/dataDictionary'
import {
  // getBillingTemplateList,
  // getBillingTemplateHistoryList,
  // SetBillingTemplateHistoryList,
  // SetBillingTemplateList,
  // DeleteBillingTemplateList,
  AddBillingTemplateList
} from '@/api/billingCustom'
import // GetTreeDate,
// SaveTreeDate,
// BingYwy,
// BingKDY,
// get_Server_Area,
// EditorArea
'@/api/areaData'
import {
  get_WeixinCouponSet,
  // SaveWeixinCouponSet,
  // DeleteWeixinCouponSet,
  get_WeixinCoupon
} from '@/api/weixinCoupon'
// import { GetData, DeleteNotice } from '@/api/wXAccount'

// import { SaveAdrr } from '@/api/deliveryRecordController'
import {
  UpadeAccsf_SB,
  ChauffeurInfo_SB,
  SendOrders_Modify_SB,
  CancelSendOrders_SB,
  SaveSendOrders_Modify_SB,
  fill,
  Query_XML,
  save,
  ExcelHeavyData,
  Getsfprice,
  SavesfPriceData,
  ResetPwdChauffeurInfo_SB,
  ImportSbOrdersDetails,
  ImportData
} from '@/api/sendPack_SBController'
import {
  get_web_account_77335,
  deleteAccountInfo_77335,
  get_MyAccountInfo_77335,
  getRemainWeb_77335,
  addWebAccount_77335,
  get_web_order_77335,
  addWebAccountCZ_77335,
  addWebAccountSH_77335,
  deleteWebAccountCZ,
  get_web_account_cz_77335,
  get_accbili_byid,
  Addaccbili_82838,
  InitkaihuTemplateData_86308,
  Savejskh_86308,
  GetRatiotypeCom,
  ImportAccountChanageDetails,
  // DeleteDeliveryCharge4,
  mySaveDeliveryData,
  SaveRatio_77335,
  SaveOutacc_77335,
  Savejsbili_80799,
  Savejsbili_71316,
  Savejsbili_99128,
  Savejsbili_82838,
  Savejsbili_86308,
  SaveRatio_82233,
  SaveOutacc_82233,
  SaveDeliveryData82233
  // SaveEditPrice_77335,
  // SaveEditPrice_82233,
  // SaveEditjsbili_80799,
  // SaveEditjsbili_86308
} from '@/api/myAccountController'
import { GetModifyData_SB_QS } from '@/api/getModifyDataTwoController'
import { importData, Getdrflag } from '@/api/waybillImportController'
import {
  DeleteCustomerSignPrice,
  InitCustomerSignTemplateData,
  SaveCostomerSignPriceData,
  SaveEditCustomerPrice
} from '@/api/priceSystemController'
import {
  getFDPZ_DetailListPage,
  Getinonevehicleflag,
  fdpzZCZF,
  getFDPZ_insure,
  wlh_insure,
  selectInsurerAddr
} from '@/api/fdpzController'
import {
  deleteBill,
  Check_deleteBill,
  dptb_save
} from '@/api/acceptanceOfBill2Controller'
import {
  getDynamicType,
  getDynamicButton,
  GetSupplyRecords
} from '@/api/mybSupplyManagementController'
/**
 * .net未迁移的ajax请求统一汇总在这里
 */
export const apiInfo = {
  '/Common/GetSkinData': getSkinData,
  '/Common/GetBSite': getBSite,
  '/Notice/GET_NOTICE_NOT_READ': getNoticeNotRead,
  '/QuickFindResult/GetSuperSettingUser': getSuperSettingUser,
  // '/parmsetting/GetPageData': getPageData,
  // '/parmsetting/GetFHSITE': GetFHSITE,陈俊辉
  // '/parmsetting/addHXSITE': addHXSITE,陈俊辉
  // '/parmsetting/delHXSITE': delHXSITE,陈俊辉
  // '/parmsetting/addPZSITE': addPZSITE,陈俊辉
  // '/parmsetting/delPZSITE': delPZSITE,陈俊辉
  // '/parmsetting/addFHSITE': addFHSITE,陈俊辉
  // '/parmsetting/delFHSITE': delFHSITE,陈俊辉
  // '/parmsetting/addFEELVSITE': addFEELVSITE,陈俊辉
  // '/parmsetting/delFEELVSITE': delFEELVSITE,陈俊辉
  // '/parmsetting/addPG': addPG,陈俊辉
  // '/parmsetting/delPG': delPG,陈俊辉
  '/LoadInfo/GetArg': getArg,
  '/LoadInfo/GetConsignee': GetConsignee,
  '/LoadInfo/selectVehicleXinghao': selectVehicleXinghao,
  '/TransportResources/GetMapUrl': getMapUrl,
  '/BIchart/QSP_GET_COUNT_MONITOR': qspGetCountMonitor,
  '/Home/GetHomeStatisticsData': getHomeStatisticsData,
  '/BIchart/QSP_GET_OUT_DIRECT_MONITOR': qsoGetOutDirectMonitor,
  '/Common/GetHideFeeTypeByGroupid': getHideFeeTypeByGroupId,
  '/PublicData/GetFeetype': GetFeetype,
  // '/PublicData/Getinterval': getInterval,
  '/sysmana/GetGridColumnsByGridID': getGridColumnsByGridID,
  // '/publicData/getintervalNoAll': getIntervalNoAll,
  // '/PublicData/GetintervalNoAll': getIntervalNoAll,
  '/TransportResources/GetVehicleExpires': getVehicleExpires,
  '/sysmana/GetGridUserSettings': getGridUserSettings,
  '/sysmana/GetGridColumns': getGridColumns,
  '/sysMana/GetBackData': GetBackData,
  '/sysMana/GetDataDictionary': GetDataDictionary,
  '/sysMana/GridManaQuery': GridManaQuery,
  '/sysMana/GetPageGridBond': GetPageGridBond,
  '/sysMana/SavePGSData': SavePGSData,
  '/sysMana/GetExportModelMain': getExportModelMain,
  '/BIchart/QSP_GET_WEIGHT_MONITOR': qspGetWeightMonitor,
  '/BIchart/QSP_GET_OKPROCESS_MONITOR': qspGetOkProcessMonitor,
  '/BIchart/QSP_GET_CHAUFFER_MONITOR': qspGetChaufferMonitor,
  '/BIchart/QSP_GET_TURNOVER_MONITOR': qspGetTurnOverMonitor,
  '/PublicData/PubilcDataDecryptColumn': publicDataDecryptColumn,
  '/PublicData/PubilcDataDecrypt': PubilcDataDecrypt,
  '/PublicData/Getusername': Getusername,
  '/CheckImg/Getimg': getImg,
  '/CheckImg/getimg': GetImg, // 和上面的一样字母换成小写
  '/CheckImg/delpicture': delpicture,
  '/CheckImg/GetImgCommon': GetImgCommon,
  '/CheckImg/DelpictureByID': DelpictureByID,
  '/CheckImg/UploadImgGPYS': UploadImgGPYS,
  '/SMSPlatform/GetSmsClassData': getSmsClassData,
  '/SMSPlatform/GetClassName': getClassName,
  '/SMSPlatform/GetSmsModelData': getSmsModelData,
  '/SMSPlatform/SaveSmsModel': saveSmsModel,
  '/SMSPlatform/GetSmsManData_new': getSmsManDataNew,
  '/SMSPlatform/UploadExecl': uploadExecl,
  '/SMSPlatform/getSMSCost': getSMSCost,
  // '/PublicData/checkOutexcel': checkOutexcel,
  '/PublicData/DownLoadExportExcel2': downLoadExportExcel2,
  '/Billing/GetTydSort': getTydSort,
  '/CustomerProfiles/getSiteTree': getSiteTree,
  '/VehicleOilCard/ImportCardMaterialMain': ImportCardMaterialMain,
  '/VehicleOilCard/DeleteIntoCardMaterialExcel': DeleteIntoCardMaterialExcel,
  '/VehicleOilCard/InitializationTemplate': InitializationTemplate,
  '/VehicleOilCard/GetCardMaterialflag': GetCardMaterialflag,
  '/VehicleOilCard/ImportCardMaterialData': ImportCardMaterialData,
  '/VehicleOilCard/Get_Template_Main': Get_Template_Main,
  '/CustomerInformationTemplate/IsExistFile': IsExistFile,
  '/CustomerInformationTemplate/CustomerInformationTemplateDelete':
    CustomerInformationTemplateDelete,
  // '/CustomerInformationTemplate/SavePGSData': templateSavePGSData,
  '/CustomerInformationTemplate/GetPageGridBond': templateGetPageGridBond,
  '/VehicleOilCard/GetIntoCardMaterialExcel': GetIntoCardMaterialExcel,
  '/VehicleOilCard/CardMaterialTemplateDelete': CardMaterialTemplateDelete,
  '/VehicleOilCard/GetPageGridBond': oilCardGetPageGridBond,
  '/VehicleOilCard/SavePGSData': oilCardSavePGSData,
  '/Settlement/GetChaufferBillno': getChaufferBillno,
  // '/CheckImg/UploadImg': uploadImg, // 影响图片上传后的回调问题
  '/PublicData/GetSite': getSite,
  '/TransportResources/MyGPSinfo': myGPSinfo,
  '/VehicleXinghao/GetVehicleXinghao': getVehicleXinghao,
  '/Billing/GetShipperAgain': GetShipperAgain,
  '/ClaimsSettlement/Add_sh': Add_sh,
  '/ClaimsSettlement/AddClaimsSettlement': AddClaimsSettlement,
  '/ClaimsSettlement/CancelClaimsSettlement': CancelClaimsSettlement,
  '/QualityManage/Add_REFEREE': Add_REFEREE,
  '/GetModifyDataOne/GetModifyData_ClaimsSettlement':
    GetModifyData_ClaimsSettlement,
  // '/DeliveryRecord/Index': DeliveryRecordIndex,
  '/DeliveryRecord/PushWb': DeliveryRecordPushWb,
  '/VerifyAccend': VerifyAccend,
  '/CancelVerifyAccend': CancelVerifyAccend,
  '/QualityManage/AddCargodamageInfo': AddCargodamageInfo,
  '/QualityManage/GetCargodamageInfo': GetCargodamageInfo,
  '/QualityManage/DeleteCargodamage': DeleteCargodamage,
  '/QualityManage/CancelRShipment': CancelRShipment,
  '/PersonnelAdministration/SectorInformation': sectorInformation,
  '/paymentWelfare/GET_YGDA_INFO': GET_YGDA_INFO,
  '/paymentWelfare/get_gzori': get_gzori,
  // '/Common/Get_rowcolor': getRowcolor,
  // '/SignTheReceipt/Index': getSignIndex,
  // '/SignTheReceipt/BACK_SIGN': backSign, // 回单签收 完成
  // '/SendTheReceipt/Index': getSendIndex,
  // '/SendTheReceipt/GET_VEHICLE': getVehicle,
  // '/SendTheReceipt/BACK_BACK': backBack, // 回单寄出 完成
  // '/SignBack/Index': getBackIndex,
  // '/SignBack/BACK_BACK_BSITE': signBackBackBsite, // 签单返回 完成
  // '/SingleDepot/BACK_BACK_BSITE': backBackBsite, // 签单返厂 完成
  // '/Courier/warehousingDetails': warehousingDetails,
  // '/Courier/Get_CourierDetailsData': getCourierDetailsData,
  // '/Courier/ADD_B_KD_ORDER': addBKDorder, // 新增订单录入
  '/Courier/ScanCode': scanCode, // 出入仓明细-新增-查询订单
  '/Courier/ADD_B_KD_ORDER_detail': ADD_B_KD_ORDER_detail, // 出入仓明细-新增-修改
  '/Courier/B_KD_ORDER_detail': B_KD_ORDER_detail, // 出入仓明细-新增-删除
  '/Courier/warehousingManagement': warehousingManagement, // 出入仓管理提取

  '/Courier/ORDERENTERInfo_wid': ordeRenterInfoWid, // 获取数据生成运单
  '/Courier/Del_B_KD_ORDER': Del_B_KD_ORDER, // 删除运单

  '/QualityManage/BILLNO_getunit': BILLNO_getunit,
  '/DeliveryRecord/SaveAdrr': SaveAdrr,
  '/PublicData/GetSiteRole': GetSiteRole,
  '/SendPack_SB/SendOrders_Modify_SB': SendOrders_Modify_SB,
  '/SendPack_SB/UpadeAccsf_SB': UpadeAccsf_SB,
  '/SendPack_SB/ChauffeurInfo_SB': ChauffeurInfo_SB,
  '/SendPack_SB/CancelSendOrders_SB': CancelSendOrders_SB,
  '/SendPack_SB/SaveSendOrders_Modify_SB': SaveSendOrders_Modify_SB,
  '/Common/Get_rowcolor': Get_rowcolor,
  '/PublicData/DownLoadExportExcel': downLoadExportExcel,
  '/PublicData/DownLoadExportExcel3': downLoadExportExcel3,
  '/MyAccount/get_web_account_77335': get_web_account_77335,
  '/MyAccount/InitkaihuTemplateData_86308': InitkaihuTemplateData_86308,
  '/MyAccount/DeleteAccountInfo_77335': deleteAccountInfo_77335,
  '/MyAccount/get_web_account_cz_77335': get_web_account_cz_77335,
  '/MyAccount/Savejskh_86308': Savejskh_86308,
  '/MyAccount/GetRatiotypeCom': GetRatiotypeCom,
  '/myaccount/get_MyAccountInfo_77335': get_MyAccountInfo_77335,
  '/myaccount/AddWebAccount_77335': addWebAccount_77335,
  '/myaccount/AddWebAccountCZ_77335': addWebAccountCZ_77335,
  '/myaccount/Addaccbili_82838': Addaccbili_82838,
  '/myaccount/DeleteWebAccountCZ': deleteWebAccountCZ,
  '/myaccount/AddWebAccountSH_77335': addWebAccountSH_77335,
  '/myaccount/get_accbili_byid': get_accbili_byid,
  '/MyAccount/GetRemainWeb_77335': getRemainWeb_77335,
  '/MyAccount/ImportAccountChanageDetails': ImportAccountChanageDetails,
  '/MyAccount/get_web_order_77335': get_web_order_77335,
  '/GetModifyDataTwo/GetModifyData_SB_QS': GetModifyData_SB_QS,
  '/Common/Add_rowcolor': Add_rowcolor,
  '/SendPack_SB/fill': fill,
  '/SendPack_SB/Query_XML': Query_XML,
  '/SendPack_SB/save': save,
  '/SendPack_SB/ExcelHeavyData': ExcelHeavyData,
  '/SendPack_SB/Getsfprice': Getsfprice,
  '/SendPack_SB/SavesfPriceData': SavesfPriceData,
  '/SendPack_SB/ResetPwdChauffeurInfo_SB': ResetPwdChauffeurInfo_SB,
  '/SendPack_SB/ImportSbOrdersDetails': ImportSbOrdersDetails,
  '/SendPack_SB/ImportData': ImportData,
  '/waybillImport/ImportData': importData,
  '/priceSystem/DeleteCustomerSignPrice': DeleteCustomerSignPrice,
  '/priceSystem/InitCustomerSignTemplateData': InitCustomerSignTemplateData,
  '/waybillImport/Getdrflag': Getdrflag,
  '/priceSystem/SaveCostomerSignPriceData': SaveCostomerSignPriceData,
  '/priceSystem/SaveEditCustomerPrice': SaveEditCustomerPrice,
  '/fdpz/getFDPZ_DetailListPage': getFDPZ_DetailListPage,
  '/fdpz/Getinonevehicleflag': Getinonevehicleflag,
  '/fdpz/fdpzZCZF': fdpzZCZF,
  '/AcceptanceOfBill2/deleteBill': deleteBill,
  '/AcceptanceOfBill2/Check_deleteBill': Check_deleteBill,
  '/AcceptanceOfBill2/dptb_save': dptb_save,
  '/fdpz/getFDPZ_insure': getFDPZ_insure,
  '/fdpz/wlh_insure': wlh_insure,
  '/fdpz/selectInsurerAddr': selectInsurerAddr,
  '/MybSupplyManagement/getDynamicType': getDynamicType,
  '/MybSupplyManagement/getDynamicButton': getDynamicButton,
  '/MybSupplyManagement/GetSupplyRecords': GetSupplyRecords,
  '/GetModifyDataOne/GetModifyData_Company': GetModifyData_Company,
  '/GetModifyDataOne/GetModifyData_Users': GetModifyData_Users,
  '/GetModifyDataOne/GetModifyData_BillingTemplateList':
    GetModifyData_BillingTemplateList,
  '/GetModifyDataOne/GetModifyData_Warehousing_76972':
  GetModifyData_Warehousing_76972,
  // '/zzjg/SaveLinesOrder': SaveLinesOrder,陈俊辉
  '/zzjg/B_other_company': B_other_company,
  // '/zzjg/codeData': codeData,陈俊辉
  // '/zzjg/LinesData': LinesData,陈俊辉
  // '/zzjg/bsiteData': bsiteData,陈俊辉
  // '/zzjg/SaveBatchList': SaveBatchList,陈俊辉
  // '/priceSystem/GetSendAreaPrice': GetSendAreaPrice,
  // '/priceSystem/GetSendStartPrice': GetSendStartPrice,
  '/priceSystem/AddPriceRange': AddPriceRange,
  '/priceSystem/DeletePriceRange': DeletePriceRange,
  '/priceSystem/UpdateRangeMinValue': UpdateRangeMinValue,
  // '/priceSystem/DeleteDeliveryCharge': DeleteDeliveryCharge,
  // '/priceSystem/DeleteDeliveryCharge3': DeleteDeliveryCharge3,
  // '/priceSystem/DeleteDeliveryCharge78633': DeleteDeliveryCharge78633,
  // '/priceSystem/DeleteDeliveryCharge86250': DeleteDeliveryCharge86250,
  '/priceSystem/InitCarriageTemplateData': InitCarriageTemplateData,
  // '/priceSystem/add': priceSystemAdd,
  '/priceSystem/SaveDeliveryData': SaveDeliveryData,
  '/priceSystem/SaveCarriageData': SaveCarriageData,
  '/priceSystem/SaveCarriageData2': SaveCarriageData2,
  '/priceSystem/SaveDeliveryData86250': SaveDeliveryData86250,
  '/priceSystem/SaveSendData': SaveSendData,
  '/priceSystem/SaveSafeData': SaveSafeData,
  '/priceSystem/SaveJincangData79710': SaveJincangData79710,
  '/priceSystem/SaveCarriageData_76955': SaveCarriageData_76955,
  '/priceSystem/SaveCarriageData_80799': SaveCarriageData_80799,
  '/priceSystem/SaveCarriageData_81930': SaveCarriageData_81930,
  '/priceSystem/saveCarriageData_96209': SaveCarriageData_96209,
  '/priceSystem/SaveCarriageData_81003': SaveCarriageData_81003,
  '/priceSystem/SaveCarriageData_82622': SaveCarriageData_82622,
  '/priceSystem/SaveCarriageData_79358': SaveCarriageData_79358,
  '/priceSystem/SaveCarriageData_80028': SaveCarriageData_80028,
  '/priceSystem/SaveData_GroundLine': SaveData_GroundLine,
  '/priceSystem/SaveData_Other': SaveData_Other,
  '/priceSystem/SaveDataComm': SaveDataComm,
  // '/priceSystem/SaveLinePriceData': SaveLinePriceData,
  // '/priceSystem/SaveItemPriceData': SaveItemPriceData,
  '/priceSystem/SaveFyAddressData': SaveFyAddressData,
  // '/priceSystem/SaveEditPrice': SaveEditPrice,
  // '/priceSystem/SaveEditPrice78633': SaveEditPrice78633,
  // '/priceSystem/SaveEditPrice79710': SaveEditPrice79710,
  // '/priceSystem/SaveEditPrice80028': SaveEditPrice80028,
  // '/priceSystem/SaveEditPrice81003': SaveEditPrice81003,
  // '/priceSystem/SaveEditPrice79323': SaveEditPrice79323,
  // '/priceSystem/SaveEditPrice82622': SaveEditPrice82622,
  // '/priceSystem/SaveEditPrice79358': SaveEditPrice79358,
  // '/priceSystem/SaveEditPriceComm': SaveEditPriceComm,
  // '/priceSystem/SaveEditPrice86250': SaveEditPrice86250,
  '/rptMana/rpttypeQuery': rpttypeQuery,
  '/rptMana/rptModelManaDelete': rptModelManaDelete,
  '/rptMana/rptModelManaSetDefault': rptModelManaSetDefault,
  '/rptMana/rptModelManaRemoveDefault': rptModelManaRemoveDefault,
  '/rptMana/getModelByTypeID': getModelByTypeID,
  // '/rptMana/GetModelVersion': GetModelVersion,
  '/rptMana/UseModelVersion': UseModelVersion,
  '/rptMana/rptmodelSave': rptmodelSave,
  '/rptMana/CopyModelVersion': CopyModelVersion,
  // '/rptMana/rptmodelSaveLog': rptmodelSaveLog,
  // '/rptMana/rptmodelSave_rl_new': rptmodelSave_rl_new,
  // '/pinchebao/seleteCenterInfo': seleteCenterInfo,
  // '/permissiongroup/NPage_GetPermissList': NPage_GetPermissList,
  // '/czy/GetBSite': GetBSite,
  // '/czy/ModifyUser_post': ModifyUser_post,陈俊辉
  // '/czy/GetDDUser': GetDDUser,陈俊辉
  // '/InventoryManagement/GetWarehouseChildrenByID': GetWarehouseChildrenByID,陈俊辉
  // '/toggleSite/ChangPassWord_post': ChangPassWord_post,
  // '/BindingEquipment/audit': audit,陈俊辉
  // '/BindingEquipment/delete': deleteBind,陈俊辉
  // '/MyAccount/DeleteDeliveryCharge4': DeleteDeliveryCharge4,
  '/MyAccount/SaveDeliveryData': mySaveDeliveryData,
  '/MyAccount/SaveRatio_77335': SaveRatio_77335,
  '/MyAccount/SaveOutacc_77335': SaveOutacc_77335,
  '/MyAccount/Savejsbili_80799': Savejsbili_80799,
  '/MyAccount/Savejsbili_71316': Savejsbili_71316,
  '/MyAccount/Savejsbili_99128': Savejsbili_99128,
  '/MyAccount/Savejsbili_82838': Savejsbili_82838,
  '/MyAccount/Savejsbili_86308': Savejsbili_86308,
  '/MyAccount/SaveRatio_82233': SaveRatio_82233,
  '/MyAccount/SaveOutacc_82233': SaveOutacc_82233,
  '/MyAccount/SaveDeliveryData82233': SaveDeliveryData82233,
  // '/MyAccount/SaveEditPrice_77335': SaveEditPrice_77335,
  // '/MyAccount/SaveEditPrice_82233': SaveEditPrice_82233,
  // '/MyAccount/SaveEditjsbili_80799': SaveEditjsbili_80799,
  // '/MyAccount/SaveEditjsbili_86308': SaveEditjsbili_86308,
  '/baseSetting/selectpackpagesbysite': selectpackpagesbysite,
  '/baseSetting/selectProductcode': selectProductcode,
  // '/baseSetting/selectVolumgesetupbysite': selectVolumgesetupbysite,
  // '/baseSetting/selectWeightgesetupbysite': selectWeightgesetupbysite,
  '/baseSetting/addProductcode': addProductcode,
  '/baseSetting/deleteProductcode': deleteProductcode,
  '/loadinfo/GetConsignee': GetConsignee,
  '/ImportTemplate/IsExistFile': importTemplateIsExistFile,
  '/ImportTemplate/SavePGSData': importSavePGSData,
  '/ImportTemplate/GetPageGridBond': importGetPageGridBond,
  '/ImportTemplate/InitializationTemplate': importInitializationTemplate,
  '/GoodsTrackingTemplate/CustomerInformationTemplateDelete':
    goodsCustomerInformationTemplateDelete,
  '/GoodsTrackingTemplate/GetPageGridBond': goodsCustomerGetPageGridBond,
  '/GoodsTrackingTemplate/SavePGSData': goodsCustomerSavePGSData,
  '/WarehouseManagement/WarehouseTemplateDelete': WarehouseTemplateDelete,
  // '/WarehouseManagement/SavePGSData': WarehouseSavePGSData,
  '/ImportWarehouse/GetPageGridBond': warehouseGetPageGridBond,
  '/DataDictionary/DataDictionaryMapping': DataDictionaryMapping,
  // '/BillingCustom/GetBillingTemplateList': getBillingTemplateList,
  // '/BillingCustom/GetBillingTemplateHistoryList': getBillingTemplateHistoryList,
  // '/BillingCustom/SetBillingTemplateHistoryList': SetBillingTemplateHistoryList,
  // '/BillingCustom/SetBillingTemplateList': SetBillingTemplateList,
  // '/BillingCustom/DeleteBillingTemplateList': DeleteBillingTemplateList,
  '/BillingCustom/AddBillingTemplateList': AddBillingTemplateList,
  // '/AreaData/GetTreeDate': GetTreeDate,
  // '/AreaData/SaveTreeDate': SaveTreeDate,
  // '/AreaData/BingYwy': BingYwy,
  // '/AreaData/BingKDY': BingKDY,
  // '/AreaData/get_Server_Area': get_Server_Area,
  // '/AreaData/EditorArea': EditorArea,
  '/WeixinCoupon/get_WeixinCouponSet': get_WeixinCouponSet,
  // '/WeixinCoupon/SaveWeixinCouponSet': SaveWeixinCouponSet,
  // '/WeixinCoupon/DeleteWeixinCouponSet': DeleteWeixinCouponSet,
  '/WeixinCoupon/get_WeixinCoupon': get_WeixinCoupon
  // '/WXAccount/GetData': GetData,
  // '/WXAccount/DeleteNotice': DeleteNotice
}

// 0427新增去掉 ../ 方法
// /PublicData/DownLoadExportExcel
// /PublicData/DownLoadExportExcel2
// /PublicData/DownLoadExportExcel3

// /paymentWelfare/payrollWrite_off
// /QualityManage/GetCargodamageInfo
// /QualityManage/AddCargodamageInfo
// /TransportResources/GetVehicleCOMEFROM
// /TransportResources/AddSectionRatesInfo
// /TransportResources/AddRatesInfo
// /TransportResources/AddVehicleArchives_Cheimg80655
// /TransportResources/AddVehicleArchives
// /AccountsPayable/SelectSubjectsView
// /Common/loadDataFromFile
